import React from "react";
import { Helmet } from "react-helmet";
import oneconverse from "../../images/hero.png";

const Head = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://oneconverse.com" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={oneconverse} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://oneconverse.com" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={oneconverse} />
    </Helmet>
  );
};

Head.defaultProps = {
  title: "Certified Translation services-Interpretation | localization",
  description:
    "Oneconverse is a trusted translation & interpretation agency. Go global with our certified translation, interpretation services, and translators near you.",
  keywords:
    "translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations",
};

export default Head;
